import { WEB_COMPONENT_PATCH_SCAN } from 'apps/webcomponents/src/webcomponents.constants';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from './view/styles';
import { translateFn } from '../../../../../utils/translator.helper';
import { FontSizes, LineHeights } from '../../../../../types/common/types';

@customElement(WEB_COMPONENT_PATCH_SCAN)
export class GzPatchScanWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  protected render() {
    return html`<gz-text class="patch-scan-text" lineHeight="${LineHeights.SMALL}" fontSize="${FontSizes.HEADING_6}">
      ${translateFn('You are about to start a patch scan on the selected entities.')}
    </gz-text>`;
  }
}
